import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d8af999"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ml-12" }

import translate from '@/api/translate';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'ClearBtn',
  emits: ["change"],
  setup(__props, { emit: __emit }) {

	const emits = __emit;

	const Reset = () => {
		emits("change");
	};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, {
      class: "remove-btn",
      plain: "",
      onClick: Reset
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(translate).ShowText('清空')), 1)
      ]),
      _: 1
    })
  ]))
}
}

})